import { Link } from "react-router-dom";
import Slider from "react-slick";
import * as ROUTES from "../../constants/routes";
import { useEffect, useRef, useState } from "react";



const HeroCarousel = () => {
    const headlineRefs = useRef([]);
    const labelRefs = useRef([]);
    const [rightOffsets, setRightOffsets] = useState([]);


    const slides = [
        {
            label: "Company?",
            headline: <>Get Investment or Exit Ready</>,
            subHeadLine: "Simply"
        },
        {
            label: "Advisors?",
            headline: <>Get Your Clients Organised</>,
            subHeadLine: "Simply"
        },
        {
            label: "Investor?",
            headline: <>Cost-effective Diligence</>,
            subHeadLine: "Simply"
        },
        {
            label: "Automated Diligence",
            subHeadLine: "Simply"
        },
    ]

    // useEffect(() => {
    //     const newOffsets = slides.map((slide, index) => {
    //         const ref = slide.headline
    //             ? headlineRefs.current[index]
    //             : labelRefs.current[index];

    //         if (ref) {
    //             const width = ref.offsetWidth;
    //             const parentWidth = ref.parentElement.offsetWidth;
    //             return parentWidth - width;
    //         }
    //         return 0;
    //     });

    //     setRightOffsets(newOffsets);
    // }, [slides]);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1, initialSlide: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
    };

    return (
        <section className="silder-box pr" style={{ padding: "7px 0px" }}>
            <div className="row df pr px2rem sm-fdc" style={{ flexWrap: "nowrap" }}>
                {/* Left */}
                <div
                    className="col-sm df fdc gg3rem sm-w100 sm-maw100"
                    style={{ maxWidth: '60%', height: "100%" }}
                >
                    <div className="fs1-5rem c15 tslp mt1rem ml3rem xl-ml0rem" style={{ lineHeight: '28px' }}>
                        Welcome to Diligentsia
                    </div>

                    <Slider {...settings}>
                        {slides.map(({ label, headline, subHeadLine }, index) => (
                            <div key={index} className="df fdc">
                                <div className="fw500 c15 tslp" style={{ fontSize: '48px', lineHeight: '58px' }}>
                                    <span
                                        className="c4 mb1rem"
                                    // ref={el => (labelRefs.current[index] = el)}
                                    >
                                        {label}
                                    </span>
                                    {headline && (
                                        <span
                                        // ref={el => (headlineRefs.current[index] = el)}
                                        >
                                            <br />
                                            {headline}
                                        </span>
                                    )}
                                    <br />
                                    <div
                                        // className="tar"
                                        style={{
                                            // paddingRight: `${rightOffsets[index] || 0}px`,
                                            // transition: 'padding-right 0.3s ease'
                                        }}
                                    >
                                        {subHeadLine}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>

                    {/* <p className="fs1-25rem c15 tslp ml3rem xl-ml0rem" style={{ marginTop: '-30px' }}>
                        Diligentsia's low cost AI platform quickly adds value to companies, their advisors and investors throughout a company's life cycle - investment - growth - exit.
                    </p> */}

                    {/* Climb26 button */}
                    {/* <Link to={ROUTES.LANDING_PAGE_CLIMB26} className="w100 mt1rem ml6rem xxl-mt0rem xl-ml0rem ">
                        <img className="df sm-w120px" src={require('../../../images/climb26-button.png')} width={200} alt="Climb26 Button" />
                    </Link> */}
                </div>

                {/* Right image */}
                <div
                    className="col-sm df jce pr md-w100 md-maw100 md-my2rem"
                    style={{
                        backgroundImage: `url(${require('../../../images/landingpage/form-background-2.webp')})`,
                        backgroundPosition: 'center',
                        width: '70%',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <div className="pr df aic jcc">
                        <img className="w80" src={require('../../../images/homePageCogGraphic.svg')} alt="Hero" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroCarousel;
